import {
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
    BlockWrapper,
} from '@smartfire/js-block-engine'
import clsx from 'clsx'
import React, { useCallback, useState } from 'react'
import style from './block.module.scss'
import { ReactComponent as Arrow } from '../assets/arrow.svg'

const Inspector = React.lazy(() => import('./Inspector'))

const Button = ({
    text,
    link,
    externalLink,
    internalLink,
    linkType,
    blank,
    aspect,
    color,
    colorHover,
    position,
    classNames,
    icon = undefined,
    onClick = undefined,
    Wrapper = 'a',
    inspector = true,
    ...props
}) => {
    useInspectorControl(() => (inspector ? <Inspector active={inspector} /> : <></>))
    const { isEditing } = useEditor()
    const [isHover, setIsHover] = useState(false)

    const inlineStyle = useCallback(
        (color) => ({
            color: aspect !== 'contained' ? color : 'white',
            backgroundColor: aspect === 'contained' ? color : 'transparent',
            borderColor: aspect !== 'ghost' && aspect !== 'arrow' ? color : null,
        }),
        [aspect],
    )

    let url = link ? link : linkType === 'internal' ? internalLink : externalLink

    return (
        <BlockWrapper.Div
            className={clsx(style.block, style[position], style[aspect], 'button_front')}
        >
            <Wrapper
                href={!isEditing ? url : undefined}
                target={blank ? '_blank' : undefined}
                onClick={onClick}
                className={clsx(style.button, classNames)}
                style={isHover ? inlineStyle(colorHover) : inlineStyle(color)}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                {...props}
            >
                {icon}
                {text}
                {aspect === 'ghost' && (
                    <div
                        className={style.underline}
                        style={{ backgroundColor: isHover ? colorHover : color }}
                    />
                )}
                {aspect === 'arrow' && <Arrow className={style.arrow} />}
            </Wrapper>
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: Button,
    smartProps: {
        text: smartProps.string.withDefault('Texte du bouton'),
        internalLink: smartProps.string.withDefault(''),
        externalLink: smartProps.string.withDefault(''),
        linkType: smartProps.string.withDefault('internal'),
        blank: smartProps.bool.withDefault(false),
        aspect: smartProps.string.withDefault('contained'),
        position: smartProps.string.withDefault('left'),
        color: smartProps.string.withDefault('#044251'),
        colorHover: smartProps.string.withDefault('#086d84'),
    },
    setup: {
        title: 'Bouton',
    },
})
